import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '20px', lineHeight: '1.6' }}>
      <h1 style={{ fontSize: '2.5rem'}}>📋Listify</h1>
      <p style={{ fontSize: '1.2rem', fontStyle: 'italic', color: '#555' }}>
        "Simplify Your Day" <br /> "Your Tasks, Your Way"
      </p>
      
      <p>
        Welcome to <strong>Listify</strong>, your ultimate productivity partner! 🎉 
        Life gets busy, but staying organized doesn't have to be hard. With Listify, 
        you can manage your tasks effortlessly and make every day more productive. 🚀
      </p>

      <h2 style={{ fontSize: '1.5rem'}}>✨Why Choose Listify?</h2>
      <ul>
        <li>📝Quickly add, edit, and organize your tasks.</li>
        <li>📱Access your tasks anytime, anywhere.</li>
        <li>🎯Focus on what matters with a clean and simple interface.</li>
        <li>🚀Stay on track and achieve your goals, one task at a time.</li>
      </ul>

      <h2 style={{ fontSize: '1.5rem'}}>🎯Our Mission</h2>
      <p>
        At <strong>Listify</strong>, we believe in empowering you to take control of your day. 🌈 
        Whether you're managing personal errands, professional projects, or creative ideas, 
        our goal is to simplify your life and help you reach your full potential. 💡
      </p>
    </div>
  );
};

export default About;

